import { render, staticRenderFns } from "./waterfall.vue?vue&type=template&id=54a3580e&scoped=true"
import script from "./waterfall.vue?vue&type=script&lang=js"
export * from "./waterfall.vue?vue&type=script&lang=js"
import style0 from "./waterfall.vue?vue&type=style&index=0&id=54a3580e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3580e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a3580e')) {
      api.createRecord('54a3580e', component.options)
    } else {
      api.reload('54a3580e', component.options)
    }
    module.hot.accept("./waterfall.vue?vue&type=template&id=54a3580e&scoped=true", function () {
      api.rerender('54a3580e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/waterfall/waterfall.vue"
export default component.exports